var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"var(--v-grey-darken-1)","d":"M21.707 3.707a1 1 0 0 0-1.414-1.414l1.414 1.414ZM2 21a1 1 0 0 0 1 1h9a1 1 0 1 0 0-2H4v-8a1 1 0 1 0-2 0v9ZM20.293 2.293l-18 18 1.414 1.414 18-18-1.414-1.414Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }